import { Injectable, Injector } from "@angular/core";
import { finalize } from "rxjs/operators";
import { SavingEmitterService } from "./emitters/saving-emitter.service";
import { TranslateService, LangChangeEvent } from "@ngx-translate/core";
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from "@angular/common/http";
import { Observable } from "rxjs";
import { OidcSecurityService } from "angular-auth-oidc-client";

@Injectable()
export class Interceptor implements HttpInterceptor {
  private authService: OidcSecurityService;
  public lang: string = "en";
  constructor(
    private injector: Injector,
    private savingService: SavingEmitterService,
    translate: TranslateService
  ) {
    translate.onLangChange.subscribe((lang) => {
      this.lang = lang.lang;
    });
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let requestToForward = req;

    if (this.authService === undefined) {
      this.authService = this.injector.get(OidcSecurityService);
    }
    if (this.authService !== undefined) {
      this.authService.getAccessToken().subscribe(token => {
        if (token !== "") {
          let tokenValue = "Bearer " + token;
          requestToForward = req.clone({
            setHeaders: {
              Authorization: tokenValue,
              "Accept-Language": this.lang,
            },
          });
        }
      });
    } else {
      //console.debug("Ripoooo");
    }

    return next.handle(requestToForward).pipe(
      finalize(() => {
        this.savingService.sendMessage(false);
      })
    );
  }
}
